import { parseFolders } from './parsers/folders';
import { toError } from './parsers/error';
export function initFolders(settings, http) {
  function list(folderId, options) {
    options = options || {};
    options.paging = options.paging || {};
    const requestOptions = {
      maxResults: options.paging.size || settings.foldersLimit,
      pageToken: options.paging.cursor || ''
    };
    if (folderId) {
      requestOptions.album_id = folderId;
    }
    return http.get(`${settings.apiUrl}${settings.apiPath}/albums`, requestOptions, {
      withCredentials: true
    }).then(parseFolders).then(res => ({
      ...res,
      data: res.data.map(folder => ({
        ...folder,
        parentId: folderId
      }))
    })).catch(toError);
  }
  return {
    list
  };
}